<script>
    /** @type {import('../types.d').ReadableRace} */
    export let race;

    $: time = new Date($race.time).toString()
    $: prefix = $race.time.split('-')[0]
  </script>

  <p>{prefix} - {time}</p>
  